module.exports = __webpack_public_path__ + "62875518289c5e73408ac9ba68012002.png";